<div class="toggle" role="group" aria-label="Гранулярност на данните">
  <button
    type="button"
    [class.active]="value() === 'month'"
    (click)="change.emit('month')"
  >
    По месеци
  </button>
  <button
    type="button"
    [class.active]="value() === 'year'"
    (click)="change.emit('year')"
  >
    По години
  </button>
</div>
